const config = {
  server: {
    // web: 'http://127.0.0.1:3333/api/v1',
    web: 'https://v3.hydrodrip.ai/api/v1', // prod
    // web: 'https://hydrodrip.ai:3000/api/v1', // test
  },
  app: {
    name: 'HYDRODRIP',
    error: 'You are not authorized to perform this action',
  },
  theme: {
    color: {
      default: '#265dec',
    },
  },
}
export default config
